var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpiUpdate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.71 11.29a.996.996 0 1 0-1.41 1.41l1 1c.18.2.44.3.7.3h.07a1 1 0 0 0 .73-.4l3-4c.33-.44.24-1.07-.2-1.4-.44-.33-1.07-.24-1.4.2l-2.31 3.08-.18-.19z",
    fill: "#ff0000",
    className: "fill-000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12c0 1.65-1.35 3-3 3s-3-1.35-3-3 1.35-3 3-3c.55 0 1-.45 1-1s-.45-1-1-1c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5c0-.55-.45-1-1-1s-1 .45-1 1z",
    fill: "#ff0000",
    className: "fill-000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11h-1.15c-.24 0-.44-.18-.48-.42a8.023 8.023 0 0 0-1.3-3.14.5.5 0 0 1 .05-.64l.73-.73c.28-.28.28-.6.08-.79l-.71-.71c-.2-.2-.51-.2-.71 0l-.81.82a.5.5 0 0 1-.64.05c-.92-.64-1.99-1.1-3.14-1.3a.511.511 0 0 1-.42-.49V2.62c0-.4-.22-.62-.5-.62h-1c-.28 0-.5.22-.5.5v1.15c0 .24-.18.44-.42.48-1.15.21-2.22.66-3.14 1.3-.2.15-.46.13-.64-.04l-.81-.81c-.2-.2-.51-.2-.71 0l-.7.7c-.2.2-.2.51 0 .71l.81.81a.5.5 0 0 1 .05.64c-.64.92-1.1 1.99-1.3 3.14-.05.24-.25.42-.49.42H2.5c-.28 0-.5.22-.5.5v1c0 .28.22.5.5.5h1.15c.24 0 .44.18.48.42.21 1.15.66 2.22 1.3 3.14a.5.5 0 0 1-.05.64l-.81.81c-.2.2-.2.51 0 .71l.71.71c.2.2.51.2.71 0l.81-.81a.5.5 0 0 1 .64-.05c.92.64 1.99 1.1 3.14 1.3.24.04.42.24.42.48v1.15c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-1.15c0-.24.18-.44.42-.48 1.15-.21 2.22-.66 3.14-1.3a.5.5 0 0 1 .64.05l.81.81c.2.2.51.2.71 0l.71-.71c.2-.2.2-.51 0-.71l-.81-.81a.5.5 0 0 1-.05-.64c.64-.92 1.1-1.99 1.3-3.14.04-.24.24-.42.48-.42h1.15c.28 0 .5-.22.5-.5v-1c0-.28-.22-.5-.5-.5zm-3.65 2.37c-.49 2.2-2.27 3.98-4.47 4.47-4.38.98-8.2-2.84-7.23-7.21.49-2.2 2.27-3.98 4.47-4.47 4.38-.98 8.2 2.84 7.23 7.21z",
    fill: "#ff0000",
    className: "fill-000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpiUpdate);
export default __webpack_public_path__ + "static/media/epi-update.0cce73ef1785fef18d82dd7a2bb1eeab.svg";
export { ForwardRef as ReactComponent };